import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { OtpForm } from '../components/OtpForm';
// import LanguageSelector from '../components/LanguageSelector'; // UI 제거 (기능은 유지)

export function OtpPage() {
  const { t } = useTranslation();

  return (
    <Layout>
      {/* <LanguageSelector /> */} {/* UI 제거 (기능은 유지) */}
      <Container>
        <Title>{t('otp.title')}</Title>
        <OtpForm />
      </Container>
    </Layout>
  );
}

const Title = styled.h1`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80px;
  ${({ theme }) => theme.typography.BOLD_36}
  text-align: center;
  color: #495264;
  margin-top: 90px;
  margin-bottom: 40px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 700px;
  height: 560px;
`;

const Layout = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
`;
